import styled from "styled-components";

export const FileUploaderContainer = styled.div`
  margin: 10px 0;
`;

export const DropZone = styled.div`
  width: 100%;
  min-height: 50px;
  border: 2px dashed ${({ isDragging }) => (isDragging ? "#F0292A" : "#cccccc")};
  border-radius: 8px;
  background-color: ${({ isDragging }) => (isDragging ? "#fde7e6" : "#fafafa")};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 10px;
  font-family: "Nunito";

  &:hover {
    border-color: #f0292a;
    background-color: #fde7e6;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
    background-color: #f5f5f5;
    border-color: #e0e0e0;

    &:hover {
      border-color: #e0e0e0;
      background-color: #f5f5f5;
    }
  }
`;

export const DropZoneText = styled.div`
  color: #666;
  font-size: 14px;
  text-align: center;

  .primary-text {
    color: #f0292a;
    font-weight: 600;
  }

  .secondary-text {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const FilesContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const FileChip = styled.div`
  display: flex;
  align-items: center;
  background-color: #e9ecef;
  border: 1px solid #dee2e6;
  border-radius: 16px;
  padding: 4px 8px 4px 12px;
  font-size: 12px;
  color: #495057;
  font-family: "Nunito";
  max-width: 200px;

  &:hover {
    background-color: #dee2e6;
  }
`;

export const FileName = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 6px;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 2px;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;

  &:hover {
    background-color: #dc3545;
    color: white;
  }
`;

export const UploadIcon = styled.div`
  width: 32px;
  height: 32px;
  border: 2px solid #cccccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 16px;
`;
